import { breakpoints } from '@bnnvara/breakpoints';
import { pixelToRem } from '@bnnvara/helpers';
import styled from 'styled-components';
export const QuoteWrapper = styled.div`
  padding: 40px 8px;

  ${breakpoints.md} {
    padding: 48px 24px;
  }

  ${breakpoints.lg} {
    padding: 48px 32px;
  }

  blockquote {
    margin: 0;
    padding: 0;
    font-size: ${pixelToRem(28)};
    line-height: ${pixelToRem(34)};
    color: ${({
  theme
}) => theme.primary.lighter};
    font-weight: 900;

    ${breakpoints.md} {
      font-size: ${pixelToRem(30)};
      line-height: ${pixelToRem(36)};
    }

    ${breakpoints.lg} {
      font-size: ${pixelToRem(36)};
      line-height: ${pixelToRem(44)};
    }
  }
`;
export const Author = styled.div`
  font-size: ${pixelToRem(16)};
  line-height: ${pixelToRem(24)};
  padding-top: 12px;
  font-weight: 600;

  ${breakpoints.md} {
    padding-top: 12px;
    font-size: ${pixelToRem(18)};
    line-height: ${pixelToRem(28)};
  }

  ${breakpoints.lg} {
    padding-top: 16px;
    font-size: ${pixelToRem(20)};
    line-height: ${pixelToRem(32)};
  }
`;